export default "__VITE_ASSET__CdT9xMCm__"